import ReloadButton from './ReloadButton.js';

export default function ReloadTreeButton(props) {
	return <ReloadButton isTree={true} {...props} />;
}

